<template>
  <div class="index">
    <van-swipe class="my-swipe" :autoplay="3000" style="max-height:350px" indicator-color="white">
      <van-swipe-item style="max-height:350px">
        <img src="../assets/1.png" style="width: 100%;height: 350px;" />
      </van-swipe-item>
      <van-swipe-item style="max-height:350px">
        <img src="../assets/2.png" style="width: 100%;height: 350px;" />
      </van-swipe-item>
    </van-swipe>
    <van-cell :title="item.text" is-link v-for="(item,index) in cellList" :key="index" :to="item.url"
      class="index-cell">
      <template #icon>
        <img :src="item.img" width="50px">
      </template>
    </van-cell>

  </div>
</template>

<script>
import { getUserConfig } from '@/api/public';
export default {
  name: 'Index',
  data() {
    return {
      cellList: [
        {
          img: require('../assets/fangjia.png'),
          text: '房价查询',
          url: 'house',
        },
        // {
        //   img: require('../assets/fangdai.png'),
        //   text: '房产抵押贷款申请',
        //   url: 'load',
        // },
        {
          img: require('../assets/jisuan.png'),
          text: '房贷计算器',
          url: 'jisuan',
        },
      ],
    };
  },
  created() {
    this.$store.state.tabBar = this.$route.name;
    this.getUserConfig();
  },
  methods: {
    getUserInfos() {
      getUserConfig()
        .then((res) => {
          this.user = res.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.index-cell {
  display: flex;
  align-items: center;

  .van-cell__title {
    padding-left: 10px;
  }
}
</style>

